import React, { useState, useEffect } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import Grid from '../../../components/molecules/Grid';
import useStyles from './style';
import { COMPONENT_NAME } from './locators';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Typography from '../../../components/atoms/Typography';
import fetchService from '../../../../services/FetchService';
import { modifyApi } from '../../../../utils/urls';
import { withStyles } from '@material-ui/core/styles';
// import Button from '../../../components/atoms/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { canUseDOM } from '../../../utils/canUseDOM';
import DctSvgIcon from '../../../components/atoms/Svg';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import get from 'lodash/get';
import checkForPropsValue from '../../../utils/checkForPropsValue';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { INFO_ICON_TEXT } from '../../../../constants';
import { NoSsr } from '@material-ui/core';

const HtmlTooltip = withStyles(theme => {
  const tooltipBorder = `${pxToRem(1)} solid ${theme.mixins.Grey(200)}`;

  return {
    tooltip: {
      backgroundColor: 'transparent',
      maxWidth: 'none',
      '& .MuiTableContainer-root': {
        overflow: 'hidden',
        border: tooltipBorder,
      },
      '& .MuiTableCell-root': {
        borderColor: theme.mixins.Grey(200),
      },
      '& .MuiTooltip-arrow': {
        width: pxToRem(34),
        height: pxToRem(24),
        color: theme.palette.background.default,
      },
      '&.MuiTooltip-touch': {
        padding: `${pxToRem(4)} ${pxToRem(8)}`,
      },
    },

    popperArrow: {
      '&[x-placement*="bottom"] .MuiTooltip-arrow': {
        marginTop: pxToRem(-19),
        '&:before': {
          borderLeft: tooltipBorder,
          borderTop: tooltipBorder,
        },
      },
      '&[x-placement*="top"] .MuiTooltip-arrow': {
        marginBottom: pxToRem(-19),
        color: theme.mixins.White(),
        '&:before': {
          borderBottom: tooltipBorder,
          borderRight: tooltipBorder,
        },
      },
      [theme.breakpoints.between('lg', 1439)]: {
        '&[x-placement*="bottom"] .MuiTooltip-arrow': {
          marginTop: `${pxToRem(-18)} !important`,
        },
        '&[x-placement*="top"] .MuiTooltip-arrow': {
          marginBottom: `${pxToRem(-18)} !important`,
        },
      },
    },
  };
})(Tooltip);

const OperatingHours = props => {
  // const heading = checkForPropsValue(
  //   get(props, 'fields.operatingHoursHeading', ''),
  //   get(props, 'sitecoreContext.route.fields.operatingHoursHeading', '')
  // );
  let heading = getDictionaryText('OperatingHoursHeading');
  let operatingHours_days = getDictionaryText('operatingHours_days');
  let operatingHours_time = getDictionaryText('operatingHours_time');
  let placeId = get(props, 'sitecoreContext.route.fields.googlePlaceId', '');
  let language = get(props, 'sitecoreContext.language');
  const classes = useStyles();
  const { appConfig = {} } = props;

  const [openingObj, setOpeningObj] = useState({
    isIconVisible: true,
    text: '',
    tooltipMenuItems: [],
  });

  useEffect(() => {
    heading = getDictionaryText('OperatingHoursHeading');
    operatingHours_days = getDictionaryText('operatingHours_days');
    operatingHours_time = getDictionaryText('operatingHours_time');

    placeId = get(props, 'sitecoreContext.route.fields.googlePlaceId', '');
    language = get(props, 'sitecoreContext.language');
    const queryParam = language ? `?language=${language}` : '';
    if (canUseDOM && placeId) {
      fetchService({
        url: modifyApi(appConfig.GOOGLE_PLACES_API, {
          placeId: `${placeId.value}${queryParam}`,
        }),
      })
        .then(response => {
          const { data } = response;
          handleResponseData(data && data.result);
        })
        .catch(err => {
          console.error(err);
        });
    }
  }, [
    get(props, 'sitecoreContext.route.fields.googlePlaceId', ''),
    get(props, 'sitecoreContext.language'),
  ]);

  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(!open);
  };

  const handleResponseData = res => {
    let weekDaysHours = get(res, 'opening_hours.weekday_text');
    if (get(res, 'business_status') || weekDaysHours) {
      let currentDay = new Date().getDay();
      weekDaysHours = weekDaysHours && [
        ...weekDaysHours.slice(currentDay - 1, 7),
        ...weekDaysHours.slice(0, currentDay - 1),
      ];

      const business_status =
        res.business_status === 'CLOSED_TEMPORARILY'
          ? getDictionaryText('closedTemporarily')
          : res.business_status === 'CLOSED_PERMANENTLY'
            ? getDictionaryText('closedPermanently')
            : '';

      const openingHoursText =
        res.opening_hours && res.opening_hours.open_now
          ? getDictionaryText('openNow')
          : getDictionaryText('closedNow');

      const operationalStatus =
        openingHoursText === getDictionaryText('openNow')
          ? `${openingHoursText} | ${weekDaysHours &&
          weekDaysHours[0]
            .substring(weekDaysHours[0].indexOf(' '))
            .toLocaleLowerCase()}`
          : `${openingHoursText} |`;

      setOpeningObj({
        isIconVisible: !business_status,
        text: business_status === '' ? operationalStatus : business_status,
        tooltipMenuItems: weekDaysHours,
      });
    }
  };

  const getDaysInTable = (item, i) => {
    let [first, ...rest] = item.split(':');
    rest = rest.join(':');
    return (
      <TableRow key={`week-item-${i}`}>
        <TableCell align="left">
          <Typography variant={i === 0 ? 'body1Bold' : 'body1'} component="p">
            {first}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography variant={i === 0 ? 'body1Bold' : 'body1'} component="p">
            {rest}
          </Typography>
        </TableCell>
      </TableRow>
    );
  };

  const { text, tooltipMenuItems, isIconVisible } = openingObj || {};
  const [firstText, ...remainingText] = text && text.split('|');
  if (openingObj && text && (!isIconVisible || tooltipMenuItems)) {
    return (
      <NoSsr>
        <Grid className={classes.root} data-locator={COMPONENT_NAME}>
          <Grid container alignItems="center" className={classes.gridContainer}>
            <Grid item>
              <Typography variant="h4" component="h2">
                {heading}
              </Typography>
            </Grid>
            <Grid item className={classes.content}>
              <Typography variant="body1Bold" component="p">
                <span className="operationStatus">{firstText}</span>
                {openingObj.isIconVisible && (
                  <span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
                )}
                {remainingText}
              </Typography>
              {openingObj.isIconVisible && (
                <ClickAwayListener onClickAway={handleTooltipClose}>
                  <div>
                    <HtmlTooltip
                      onClose={handleTooltipClose}
                      open={open}
                      disableHoverListener
                      disableTouchListener
                      placement="top"
                      arrow
                      title={
                        <React.Fragment>
                          <TableContainer component={Paper}>
                            <Table size="small" className={classes.table}>
                              <TableHead className="header current">
                                <TableRow>
                                  <TableCell align="left">
                                    <Typography variant="body1Bold" component="p">
                                      {operatingHours_days}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="left">
                                    <Typography variant="body1Bold" component="p">
                                      {operatingHours_time}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody className={classes.tableBody}>
                                {tooltipMenuItems.map((item, i) =>
                                  getDaysInTable(item, i)
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </React.Fragment>
                      }
                    >
                      <div
                        className={classes.iconButton}
                        onClick={handleTooltipOpen}
                      >
                        <DctSvgIcon
                          name="InfoOutlinedIcon"
                          aria-label={INFO_ICON_TEXT}
                        />
                      </div>
                    </HtmlTooltip>
                  </div>
                </ClickAwayListener>
              )}
            </Grid>
          </Grid>
        </Grid>
      </NoSsr>
    );
  } else {
    return null;
  }
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(OperatingHours))
);
